
const ERROR_CODES = {
  GITHUB_GRAPH_QL_ERROR: 'GITHUB_GRAPH_QL_ERROR',
  GITHUB_API_V3_ERROR: 'GITHUB_API_V3_ERROR',
  GRAPHQL_FILE_NOT_FOUND: 'GRAPHQL_FILE_NOT_FOUND',
  GRAPHQL_SCHEMA_FILE_NOT_FOUND: 'GRAPHQL_SCHEMA_FILE_NOT_FOUND',
  UNEXPECTED_SCHEMA_FORMAT: 'UNEXPECTED_SCHEMA_FORMAT',
  INVALID_JSON_IN_SCHEMA: 'INVALID_JSON_IN_SCHEMA',
}

export default ERROR_CODES


// WEBPACK FOOTER //
// ./src/lib/errorCodes.js